const routes = [
    {
        path: '/solutions/global-collection',
        name: 'GlobalCollection',
        component: () => import('@/views/Solutions/GlobalCollection.vue')
    },
    {
        path: '/solutions/payments',
        name: 'Payments',
        component: () => import('@/views/Solutions/PaymentSolutions.vue')
    },
    {
        path: '/solutions/platform',
        name: 'Platform',
        component: () => import('@/views/Solutions/MerchantPlatform.vue')
    },
    {
        path: '/solutions/access',
        name: 'Access',
        component: () => import('@/views/Solutions/scenarioAccess.vue')
    },
    {
        path: '/about/policy',
        name: 'PrivacyPolicy',
        component: () => import('@/views/Aboutus/PrivacyPolicy.vue')
    },
    {
        path: '/about/aboutus',
        name: 'aboutus',
        component: () => import('@/views/Aboutus/AboutUs.vue')
    },
    {
        path: '/about/contactus',
        name: 'contactus',
        component: () => import('@/views/Aboutus/ContactUs.vue')
    },
    {
        path: '/help/center',
        name: 'HelpCenter',
        component: () => import('@/views/Help/HelpCenter.vue')
    },
    {
        path: '/resource/AcquisitionDoc',
        name: 'AcquisitionDoc',
        component: () => import('@/views/ResourceCenter/AcquisitionDoc.vue')
    },
    {
        path: '/resource/PaymentDoc',
        name: 'PaymentDoc',
        component: () => import('@/views/ResourceCenter/PaymentDoc.vue')
    },
    {
        path: '/resource/SubscriptionDoc',
        name: 'SubscriptionDoc',
        component: () => import('@/views/ResourceCenter/SubscriptionDoc.vue')
    },
    {
        path: '/login',
        name: 'LoginPage',
        component: () => import('@/components/LoginPage.vue')
    },
    {
        path: '/register',
        name: 'RegisterPage',
        component: () => import('@/components/RegisterPage.vue')
    },
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/HomePages.vue')
    }
]

export default routes
